import React, { useState, useContext, useEffect } from "react";
import { PrincipalTemplateContainer } from "./PrincipalTemplateStyled";
import { CollaborationsContext } from "../../context/collaborationsContext";
import { FormattedMessage } from 'react-intl';

import Header from './../Header/Header';
import Footer from './../Footer/Footer';
import ModalScoreCollaboration from "../../components/ModalScoreCollaboration/ModalScoreCollaboration";


export default function PrincipalTemplate({ children }) {

    const { ratePending, setRatePending } = useContext(CollaborationsContext);
    //const { showAlertGeneralError, setShowAlertGeneralError } = useContext(GeneralContext);
    const [showRatePending, setShowRatePending] = useState(false);

    useEffect(() => {
        if (ratePending.length > 0) {
            setShowRatePending(true)
        } else {
            setShowRatePending(false)
        }
    }, [ratePending])


    return (
        <PrincipalTemplateContainer>

            <Header />
            {children}
            <Footer />

            {(showRatePending) && (<ModalScoreCollaboration setShowRatePending={setShowRatePending} />)}

        </PrincipalTemplateContainer>

    )
}